import React from 'react';

const Footer = () => {
    return (
        <div style={{
            width: '100%', 
            height: '70px', 
            backgroundColor: 'black', 
            marginTop: '60px', 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '14px'
        }}>
            © 2025 Facundo Ruiz. Todos los derechos reservados.
        </div>
    );
};

export default Footer;
